import cx from 'classnames';

interface Props {
  delwinId?: string;
}

export const SplitHeader = ({ delwinId, children }: React.WithChildren<Props>) => {
  return (
    <div
      className={cx('grid w-full grid-cols-[2fr_1fr_1fr_2rem] items-center gap-5 px-4 sm:grid-cols-[1fr_3rem_8rem_3rem]')}
      data-delwin-id={delwinId}
    >
      {children}
    </div>
  );
};
